import { Button } from 'components/form/button';
import InputFormik from 'components/form/input/inputFormik';
import React from 'react';

const YoutubeLittleFormPage = (props) => {
    return (
        <>
            <InputFormik {...props} {...props.formData.video} />
            <InputFormik {...props} {...props.formData.timer} />
            <div className="d-flex justify-content-end">
                {
                    props.handleEdit &&
                    <div className="mr-1">
                        <Button color="dark" title="Cancel" onClick={props.handleEdit} />
                    </div>
                }
                <Button type="submit" title={props.handleEdit ? "Save" : "Add to dashboard"} />
            </div>
        </>
    );
};

export default YoutubeLittleFormPage;